import { RemoteFile } from '../RemoteFile/RemoteFile';
import { IRemoteFile, LoadStorageFileErrorType } from '../types';

export class RemoteImageObject {
  private nativeImage: HTMLImageElement = new Image();
  private privateObjectUrl = '';
  private privateSrc = '';
  File: new () => IRemoteFile = RemoteFile;
  errorType: LoadStorageFileErrorType | null = null;

  onload: (() => void) | null = null;
  onerror: ((err: any) => void) | null = null;
  onabort: (() => void) | null = null;

  constructor() {
    this.nativeImage.onload = (): void => {
      if (typeof this.onload === 'function') this.onload();
    };

    this.nativeImage.onerror = (err): void => {
      if (typeof this.onerror === 'function') this.onerror(err);
    };

    this.nativeImage.onabort = (): void => {
      if (typeof this.onabort === 'function') this.onabort();
    };
  }

  get image(): HTMLImageElement {
    return this.nativeImage;
  }

  get src(): string {
    return this.privateSrc;
  }

  set src(src: string) {
    this.privateSrc = src;
    this.loadImage(this.privateSrc);
  }

  get objectUrl(): string {
    return this.privateObjectUrl;
  }

  get processedSrc(): string {
    return this.objectUrl || this.src;
  }

  loadImage(url: string): void {
    const remoteFile = new this.File();
    this.errorType = null;

    remoteFile.url = url;
    remoteFile.onload = (): void => {
      if (!remoteFile.fileData) {
        this.nativeImage.src = this.privateSrc;
        return;
      }
      this.privateObjectUrl = URL.createObjectURL(remoteFile.fileData);
      this.nativeImage.src = this.privateObjectUrl;
    };
    remoteFile.onabort = this.onabort;

    remoteFile.onerror = (error: any): void => {
      this.errorType = remoteFile.errorType;
      this.onerror?.(error);
    };
  }

  public destroy(): void {
    if (this.privateObjectUrl) {
      URL.revokeObjectURL(this.privateObjectUrl);
      this.privateObjectUrl = '';
    }
    this.nativeImage.src = '';
    this.nativeImage.remove();
  }
}
